import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Line = _resolveComponent("Line");
    return (_ctx.canPlot)
        ? (_openBlock(), _createBlock(_component_Line, {
            key: 0,
            ref: "dischargeReportCurrentLineChart",
            id: "trend-chart",
            data: _ctx.renderData,
            options: _ctx.renderOptions
        }, null, 8 /* PROPS */, ["data", "options"]))
        : _createCommentVNode("v-if", true);
}
